import { html } from "lit-html";
import { useEffectWithoutCleanup, useState } from "GlobalShared/haunted/CustomHooks";
import i18next from "i18next";
import { component } from "haunted";
import classNames from "classnames";
const DEFAULTS = {
  state: "None",
  labelNo: i18next.t("No"),
  labelYes: i18next.t("Yes"),
  readonly: false,
  tooltip: "",
  customClass: ""
};
export class ChangeEvent extends CustomEvent {
  constructor(detail) {
    super("change", { detail, cancelable: true });
  }
}
export const Component = (host) => {
  const props = {
    state: host.state !== void 0 ? host.state : DEFAULTS.state,
    labelNo: host.labelNo !== void 0 ? host.labelNo : DEFAULTS.labelNo,
    labelYes: host.labelYes !== void 0 ? host.labelYes : DEFAULTS.labelYes,
    readonly: host.readonly !== void 0 ? host.readonly : DEFAULTS.readonly,
    tooltip: host.tooltip !== void 0 ? host.tooltip : DEFAULTS.tooltip,
    label: host.label,
    validationMessage: host.validationMessage,
    customClass: host.customClass !== void 0 ? host.customClass : DEFAULTS.customClass
  };
  const onClick = (newState) => {
    if (props.readonly) {
      return;
    }
    if (host.dispatchEvent(
      new ChangeEvent({
        state: newState
      })
    )) {
      setCurrentState(newState);
    }
  };
  const [currentState, setCurrentState] = useState(props.state);
  useEffectWithoutCleanup(() => {
    setCurrentState(props.state);
  }, [props.state]);
  return html`
		<div class=${props.customClass}>
			${props.label !== void 0 ? html`<label class="form-label">${props.label}${props.tooltip !== void 0 && props.tooltip.length > 0 ? html`<dc-tooltip .label=${props.tooltip}></dc-tooltip>` : ""}</label>` : ""}
			<div
				class=${classNames("wrapper border-2 rounded-md flex h-10 w-32", {
    "bg-red-200": props.validationMessage,
    "border-2 border-gray-600": !props.readonly,
    "opacity-60 pointer-events-none border-gray-400": props.readonly
  })}
			>
				<div
					class=${classNames("flex items-center justify-center basis-1/2 rounded-l-sm cursor-pointer border-r", {
    "text-black bg-gray-200 font-bold": currentState === "No",
    "border-r-gray-600": !props.readonly,
    "border-r-gray-400": props.readonly
  })}
					@click=${() => {
    if (!props.readonly) {
      onClick("No");
    }
  }}
				>
					${props.labelNo}
				</div>
				<div
					class=${classNames("flex items-center justify-center basis-1/2 rounded-r-sm cursor-pointer border-l", {
    "text-white bg-brand-primary-light font-bold": currentState === "Yes",
    "border-l-gray-600": !props.readonly,
    "border-l-gray-400": props.readonly
  })}
					@click=${() => {
    if (!props.readonly) {
      onClick("Yes");
    }
  }}
				>
					${props.labelYes}
				</div>
			</div>
			${props.validationMessage ? html` <div class="text-red-500 text-xs font-bold w-full left-0 bg-white leading-5">${props.validationMessage}</div> ` : ""}
		</div>
	`;
};
customElements.define(
  "dc-toggle",
  component(Component, {
    useShadowDOM: false,
    observedAttributes: []
  })
);
